const runtime =
  typeof window !== 'undefined' && window.__BTMALL_RUNTIME__
    ? window.__BTMALL_RUNTIME__
    : {};

const domains = runtime.domains || {};
const endpoints = runtime.endpoints || {};
const assets = runtime.assets || {};

const slash = value => (value && value.endsWith('/') ? value : `${value || ''}/`);

export const RUNTIME_ENV = {
  domains: {
    web: slash(domains.web || 'https://btmall.vn/'),
    admin: slash(domains.admin || 'https://admin.btmall.vn/'),
    cms: slash(domains.cms || 'https://cms.btmall.vn/'),
    api: slash(domains.api || 'https://api.btmall.vn/'),
    cdn: slash(domains.cdn || 'https://cdn.btmall.vn/'),
    order: slash(domains.order || 'https://order.btmall.vn/'),
    search: slash(domains.search || 'https://search.btmall.vn/'),
  },
  endpoints: {
    coreApi: slash(endpoints.coreApi || 'https://admin.btmall.vn/api/'),
    cmsPublicApi: slash(endpoints.cmsPublicApi || 'https://cms.btmall.vn/public/api/v1/'),
    platformApi: slash(endpoints.platformApi || 'https://api.btmall.vn/'),
    orderApi: slash(endpoints.orderApi || 'https://order.btmall.vn/api/'),
    shopApi: slash(endpoints.shopApi || 'https://api.btmall.vn/'),
    searchApi: slash(endpoints.searchApi || 'https://search.btmall.vn/api/'),
  },
  assets: {
    baseUrl: slash(assets.baseUrl || domains.cdn || 'https://cdn.btmall.vn/'),
    version: String(assets.version || ''),
    logo: assets.logo || 'https://cdn.btmall.vn/images/logo/logo.png',
    favicon: assets.favicon || '/favicon.ico?v=btmall-2',
  },
};

export const runtimeAsset = path => {
  if (!path) return RUNTIME_ENV.assets.baseUrl;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path;
  return `${RUNTIME_ENV.assets.baseUrl}${path.replace(/^\//, '')}`;
};

export const runtimePublicAsset = path => {
  if (!path) return path;
  const version = RUNTIME_ENV.assets.version;
  if (!version || path.startsWith('data:')) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}v=${encodeURIComponent(version)}`;
};

export default RUNTIME_ENV;
